
import { Component, Vue } from "vue-property-decorator";

import UploaderState from "@/components/NewFileUploader/NbNewUploader/UploaderState.vue";

const MESSAGES = {
  title: "Uploading...",
};

@Component({
  components: {
    UploaderState,
  },
})
export default class UploadingUploaderState extends Vue {
  MESSAGES = MESSAGES;
}
